import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./studentdetails.css";

function Studentdetail({ email }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!email) {
      setErr("No logged-in email found.");
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const res = await Axios.get(
          `https://nodei.ssccglpinnacle.com/student-details?email=${encodeURIComponent(
            email
          )}`
        );

        if (res.data?.success) {
          const onlyMine = (res.data.data || []).filter(
            (s) =>
              (s.email || "").toLowerCase().trim() ===
              (email || "").toLowerCase().trim()
          );
          setData(onlyMine.reverse());
        } else {
          setErr("Failed to load data.");
        }
      } catch (e) {
        try {
          const res2 = await Axios.get(
            "https://nodei.ssccglpinnacle.com/student-details"
          );
          if (res2.data?.success) {
            const onlyMine = (res2.data.data || []).filter(
              (s) =>
                (s.email || "").toLowerCase().trim() ===
                (email || "").toLowerCase().trim()
            );
            setData(onlyMine.reverse());
          } else {
            setErr("Failed to load data.");
          }
        } catch (e2) {
          setErr("Server error. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [email]);

  if (loading) return <div className="studentdetails-container">Loading…</div>;
  if (err) return <div className="studentdetails-container">{err}</div>;

  return (
    <div className="studentdetails-container">
      <h2>Student Data</h2>
      <div style={{ overflowX: "auto", width: "100%" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "auto",
            minWidth: "800px",
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                Student Name
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                Mobile
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                Email
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                Account Holder
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                Account Number
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>IFSC</th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>PAN</th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                Aadhar
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                Created Date
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((student) => (
              <tr key={student._id}>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {student.studentName}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {student.mobile}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {student.email}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {student.accHolder}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {student.accNumber}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {student.ifsc}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {student.pan}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {student.aadhar}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {student.createdAt
                    ? new Date(student.createdAt).toLocaleDateString("en-GB")
                    : "-"}
                </td>
              </tr>
            ))}
            {data.length === 0 && (
              <tr>
                <td colSpan={9} style={{ padding: "16px" }}>
                  No records for <strong>{email}</strong>.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Studentdetail;
